<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-left xs12 md3 px-3 v-if="!currentSupplier">
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentSupplier" style="padding-bottom: 0 !important;"></v-text-field>
          </v-flex>
          <v-flex text-xs-left xs12 md3 v-if="currentSupplier">
            <v-btn flat @click="startShowProduction" v-if="!showProduction && !currentField && !showDeliveryReport" class="bw-5">Show production</v-btn>
            <v-btn flat @click="startShowDeliveryReport" v-if="!showDeliveryReport && !currentField && !showProduction" class="bw-5">Delivery report</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 md9>
            <v-btn flat v-if="!currentSupplier" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentSupplier" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentSupplier && !showProduction && !showDeliveryReport" v-on:click="editNewSupplier" class="bw-6">Create new supplier</v-btn>
            <v-btn flat v-if="currentSupplier && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport" :disabled="saveButtonDisabled" @click="saveSupplier" class="bw-3">{{ currentSupplier.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport" @click="saveField" :disabled="saveFieldButtonDisabled" class="bw-3">{{ currentField.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentSupplier && currentSupplier.id > 0 && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport" @click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentField && currentField.id > 0 && !showProduction && !showDeliveryReport" @click="confirmDeleteFieldDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentSupplier && currentSupplier.id > 0 && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport" @click="addField" class="bw-3">Add field</v-btn>
            <v-btn flat v-if="currentSupplier && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport" @click="cancelSupplier" class="bw-3">Cancel</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport" @click="cancelField" class="bw-3">Cancel</v-btn>
            <v-btn flat v-if="showProduction" @click="printProduction" class="bw-3">Print</v-btn>
            <v-btn flat v-if="showProduction" @click="excelProduction" class="bw-3">Excel</v-btn>
            <v-btn flat v-if="showProduction" @click="endShowProduction" class="bw-3">Close</v-btn>
            <v-btn flat v-if="showDeliveryReport" @click="printDeliveryReport" class="bw-3">Print</v-btn>
            <v-btn flat v-if="showDeliveryReport" @click="excelDeliveryReport" class="bw-3">Excel</v-btn>
            <v-btn flat v-if="showDeliveryReport" @click="endShowDeliveryReport" class="bw-3">Close</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentSupplier" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredSuppliers" :search="search" hide-actions>
              <template v-slot:items="props">
                <tr @click="selectSupplier(props.item)" class="selectable">
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.number }}</td>
                  <td class="text-xs-left">{{ props.item.vat }}</td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.phone }}</td>
                  <td class="text-xs-left">{{ props.item.mobile }}</td>
                  <td class="text-xs-left">
                    <div v-html="getContractorNames(props.item)"></div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-2 px-3 v-if="currentSupplier && showProduction" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <Headline :title="currentSupplier.name" style="padding: 15px 0 5px 0;" padding-left="20px"></Headline>
            <v-data-table :headers="palletHeaders" :items="pallets" hide-actions>
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.number }}</td>
                  <td class="text-xs-left">{{ props.item.externalNumber }}</td>
                  <td class="text-xs-left">{{ props.item.stateLabel }}</td>
                  <td class="text-xs-left">{{ props.item.field ? props.item.field.address.nameAndText : '' }}</td>
                  <td class="text-xs-left"><div v-html="props.item.categoriesText"></div></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-2 px-3 v-if="currentSupplier && showDeliveryReport && deliveryReport">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <Headline :title="currentSupplier.name" style="padding: 15px 0 5px 0;" padding-left="20px"></Headline>
            <v-data-table :headers="deliveryReportHeaders" :items="deliveryReport.items" hide-actions class="deliveryReportTable">
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left" style="width: 20px; padding-left: 8px !important; padding-right: 0 !important; padding-top: 2px !important; padding-bottom: 0 !important;">
                    <div v-if="props.item.category && props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                    <div v-if="props.item.category && props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                    <div v-if="!props.item.category">&nbsp;</div>
                  </td>
                  <td class="text-xs-left" style="padding-top: 4px !important;">
                    <div v-if="props.item.category">{{ props.item.category.displayLabel }}</div>
                    <div v-if="!props.item.category" style="font-weight: bold;">Total</div>
                  </td>
                  <td class="text-xs-right" style="padding-top: 4px !important;">
                    <div :style="props.item.category ? '' : 'font-weight: bold;'">{{ props.item.amount.toLocaleString() }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-0 px-0 v-if="currentSupplier && !showProduction && !showDeliveryReport" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel v-if="currentSupplier && !(currentField || currentPickupAddress)">
              <PanelColumn title="Supplier">
                <v-flex xs4 md2>
                  <v-label>Name</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentSupplier.name" ref="name" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Supplier no.</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentSupplier.number" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>E-mail</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentSupplier.email" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>VAT no.</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentSupplier.vat" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Phone</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentSupplier.phone" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Mobile</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentSupplier.mobile" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Inactive</v-label>
                </v-flex>
                <v-flex xs8 md10>
                  <v-checkbox color="teal" v-model="currentSupplier.inactive"/>
                </v-flex>
                <v-flex xs12/>

                <v-flex xs4 md2 style="line-height: 35px;">
                  <v-label>Contractors</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-select :items="contractors" v-model="currentSupplier.contractors" item-text="name" return-object multiple/>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                </v-flex>
                <v-flex xs8 md2>
                </v-flex>
              </PanelColumn>

              <v-flex xs12 px-5 py-3 text-xs-center>
              </v-flex>

              <PanelColumn2 title="Address">
                <v-flex xs4 sm4>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.street" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.location" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.city" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.country" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs3 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.latitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs3 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.longitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.maps.addressToGeo(currentSupplier.address)" flat>Lookup geo code</v-btn>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentSupplier.address" ref="maps" height="285px"/>
              </PanelColumn2>
            </Panel>

            <Panel v-if="currentSupplier && fields.length > 0 && !(currentField || currentPickupAddress)">
              <PanelColumn title="Fields">
                <v-flex v-if="fields.length > 0" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                  <v-data-table :headers="fieldHeaders" :items="fields" hide-actions class="narrow">
                    <template v-slot:items="props">
                      <tr @click="selectField(props.item)" class="selectable supplierFields">
                        <td class="text-xs-left">{{ props.item.address.name }}</td>
                        <td class="text-xs-left">{{ props.item.address.street }}</td>
                        <td class="text-xs-left" style="width: 60px !important;">{{ props.item.address.houseNo }}</td>
                        <td class="text-xs-left" style="width: 200px !important;">{{ props.item.address.location }}</td>
                        <td class="text-xs-left" style="width: 100px !important;">{{ props.item.address.zipCode }}</td>
                        <td class="text-xs-left" style="width: 200px !important;">{{ props.item.address.city }}</td>
                        <td class="text-xs-left" style="width: 150px !important;">{{ props.item.address.country }}</td>
                        <td class="text-xs-left" style="width: 50px !important;">{{ props.item.inactive ? 'Yes' : 'No' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
          <v-flex style="overflow-y: auto;">
            <Panel v-if="currentSupplier && currentField">
              <PanelColumn2 title="Field address">
                <v-flex xs4 sm3>
                  <v-label>Name</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.name" ref="fieldName" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.street" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.location" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.city" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.country" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.address.latitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs2 sm1/>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.address.longitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.fmaps.addressToGeo(currentField.address)" flat>Lookup geo code</v-btn>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Inactive</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-checkbox color="teal" v-model="currentField.inactive"/>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentField.address" ref="fmaps" height="285px"/>
              </PanelColumn2>

              <PanelColumn2 title="Loading address">
                <v-flex xs4 sm3>
                  <v-label>Address</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-select :items="pickupAddresses" v-model="currentPickupAddressId" item-value="id" v-on:change="selectPickupAddress"></v-select>
                </v-flex>
                <v-flex xs4 sm3>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.street" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.houseNo" style="width: 75px;" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.location" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.zipCode" style="width: 100px" :readonly="currentField.pickupAddress.id > 0"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.city" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.country" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.latitude" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs2 sm1/>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.longitude" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.pamaps.addressToGeo(currentField.pickupAddress)" flat>Lookup geo code</v-btn>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentField.pickupAddress" ref="pamaps" height="285px"/>
              </PanelColumn2>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete supplier</v-card-title>
        <v-card-text v-if="currentSupplier">Are you sure you want to delete '{{ currentSupplier.name }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteSupplier">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteFieldDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete field</v-card-title>
        <v-card-text>Are you sure you want to delete this field?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteField">Yes</v-btn>
          <v-btn flat @click="confirmDeleteFieldDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">{{errorTitle && errorTitle !== '' ? errorTitle : 'Error'}}</v-card-title>
        <v-card-text>{{errorMessage}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import Maps from '../components/Maps'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import Headline from '../components/Headline'
import axios from 'axios'
import uuid from 'uuid/v4'

export default {
  name: 'Suppliers',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, Headline, Maps },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Number', value: 'number', sortable: true },
        { text: 'VAT', value: 'vat', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false },
        { text: 'Mobile', value: 'mobile', sortable: false },
        { text: 'Contractors', value: 'contractors', sortable: false }
      ],
      fieldHeaders: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Street', value: 'street', sortable: false },
        { text: 'No.', value: 'houseNo', sortable: false },
        { text: 'Location', value: 'location', sortable: false },
        { text: 'Postal code', value: 'zipCode', sortable: false },
        { text: 'City', value: 'city', sortable: false },
        { text: 'Country', value: 'country', sortable: false },
        { text: 'Inactive', value: 'inactive', sortable: false }
      ],
      palletHeaders: [
        { text: 'Pallet no.', value: 'number', sortable: true },
        { text: 'Ext. pallet no.', value: 'number', sortable: true },
        { text: 'State', value: 'state', sortable: true },
        { text: 'Field', value: 'field.address.nameAndText', sortable: true },
        { text: 'Category', value: 'categoriesText', sortable: true }
      ],
      deliveryReportHeaders: [
        { text: '', sortable: false },
        { text: 'Category', value: 'category.displayLabel', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false, align: 'right' }
      ],
      suppliers: [],
      fields: [],
      contractors: [],
      pickupAddresses: [],
      currentSupplier: null,
      currentField: null,
      currentPickupAddress: null,
      currentPickupAddressId: 0,
      confirmDeleteDialog: false,
      confirmDeleteFieldDialog: false,
      errorDialog: false,
      errorTitle: '',
      errorMessage: '',
      showProduction: false,
      pallets: [],
      showDeliveryReport: false,
      deliveryReport: null,
      filterInactive: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'suppliers' })
    this.loadSuppliers()
    this.loadContractors()
  },
  computed: {
    users: function () {
      return this.$store.state.user.users
    },
    saveButtonDisabled: function () {
      return !this.currentSupplier || this.currentSupplier.name.trim() === '' || this.currentSupplier.number.trim() === ''
    },
    saveFieldButtonDisabled: function () {
      return !this.currentField || (this.currentField.address.street.trim() === '' && this.currentField.address.houseNo.trim() === '' && this.currentField.address.location.trim() === '' && this.currentField.address.zipCode.trim() === '' && this.currentField.address.city.trim() === '' && this.currentField.address.country.trim() === '' && this.currentField.address.latitude.trim() === '' && this.currentField.address.longitude.trim() === '') || (this.currentField.pickupAddress.street.trim() === '' && this.currentField.pickupAddress.houseNo.trim() === '' && this.currentField.pickupAddress.location.trim() === '' && this.currentField.pickupAddress.zipCode.trim() === '' && this.currentField.pickupAddress.city.trim() === '' && this.currentField.pickupAddress.country.trim() === '' && this.currentField.pickupAddress.latitude.trim() === '' && this.currentField.pickupAddress.longitude.trim() === '')
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredSuppliers () {
      return this.suppliers.filter(c => this.filterInactive ? c.inactive : !c.inactive)
    }
  },
  methods: {
    loadSuppliers () {
      axios.get('/backend/rest/supplier/all')
        .then(response => {
          this.suppliers = response.data
        })
    },
    loadContractors () {
      axios.get('/backend/rest/contractor/all')
        .then(response => {
          this.contractors = response.data
          this.contractors.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    selectSupplier (item) {
      this.fields = []
      this.pickupAddresses = []
      this.currentPickupAddressId = 0
      for (let c of this.suppliers) {
        if (c.id === item.id) {
          this.currentSupplier = c
          if (this.currentSupplier.address.latitude === 0) {
            this.currentSupplier.address.latitude = ''
          }
          if (this.currentSupplier.address.longitude === 0) {
            this.currentSupplier.address.longitude = ''
          }
          break
        }
      }
      this.loadFields()
      this.loadPickupAddresses()
    },
    editNewSupplier () {
      this.fields = []
      this.pickupAddresses = []
      this.currentSupplier = {
        id: 0,
        name: '',
        number: '',
        vat: '',
        email: '',
        phone: '',
        mobile: '',
        contractor: null,
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
      this.$nextTick(() => this.$refs.name.focus())
    },
    saveSupplier () {
      axios.post('/backend/rest/supplier', this.currentSupplier)
        .then(response => {
          // console.log('Got response: ' + response)
          this.currentSupplier = null
          this.loadSuppliers()
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })
    },
    deleteSupplier () {
      axios.delete('/backend/rest/supplier/' + this.currentSupplier.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadSuppliers()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentSupplier = null
    },
    loadFields () {
      axios.get('/backend/rest/field/supplier/' + this.currentSupplier.id + '?includeInactive=true')
        .then(response => {
          this.fields = response.data
        })
    },
    selectField (item) {
      this.pickupAddresses = []
      this.currentPickupAddressId = 0
      for (let c of this.fields) {
        if (c.id === item.id) {
          this.currentField = c
          if (this.currentField.address.latitude === 0) {
            this.currentField.address.latitude = ''
          }
          if (this.currentField.address.longitude === 0) {
            this.currentField.address.longitude = ''
          }
          if (this.currentField.pickupAddress) {
            this.currentPickupAddressId = this.currentField.pickupAddress
            if (this.currentField.pickupAddress.latitude === 0) {
              this.currentField.pickupAddress.latitude = ''
            }
            if (this.currentField.pickupAddress.longitude === 0) {
              this.currentField.pickupAddress.longitude = ''
            }
          }
          break
        }
      }
      this.loadPickupAddresses()
    },
    addField () {
      this.pickupAddresses = []
      this.currentPickupAddressId = 0
      this.currentField = {
        id: 0,
        supplierId: this.currentSupplier.id,
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        },
        pickupAddress: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
      this.loadPickupAddresses()
      this.$nextTick(() => this.$refs.fieldName.focus())
    },
    saveField () {
      axios.post('/backend/rest/field', this.currentField)
        .then(response => {
          this.loadSuppliers()
          this.loadFields()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentField = null
    },
    deleteField () {
      axios.delete('/backend/rest/field/' + this.currentField.id)
        .then(response => {
          this.loadFields()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.confirmDeleteFieldDialog = false
      this.currentField = null
    },
    loadPickupAddresses () {
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          this.pickupAddresses = response.data
          this.pickupAddresses.splice(0, 0, {
            id: 0,
            street: '',
            houseNo: '',
            location: '',
            zipCode: '',
            city: '',
            country: '',
            latitude: '',
            longitude: '',
            text: ''
          })
        })
    },
    cancelSupplier () {
      // console.log('Cancel the supplier')
      this.currentSupplier = null
      this.currentField = null
      this.currentPickupAddress = null
      this.loadSuppliers()
    },
    cancelField () {
      this.currentField = null
      this.loadFields()
    },
    selectPickupAddress () {
      for (let pa of this.pickupAddresses) {
        if (pa.id === this.currentPickupAddressId) {
          this.currentField.pickupAddress = pa
          if (this.currentField.pickupAddress) {
            if (this.currentField.pickupAddress.latitude === 0) {
              this.currentField.pickupAddress.latitude = ''
            }
            if (this.currentField.pickupAddress.longitude === 0) {
              this.currentField.pickupAddress.longitude = ''
            }
          }
          break
        }
      }
    },
    startShowProduction () {
      this.loadPallets()
      this.showProduction = true
    },
    printProduction () {
      let url = '/backend/print/supplierProduction.xhtml?supplierId=' + this.currentSupplier.id + '&title=Production'
      window.open(url)
    },
    excelProduction () {
      let url = '/backend/report/productionReport/supplier?supplierId=' + this.currentSupplier.id + '&uuid=' + uuid()
      window.open(url)
    },
    endShowProduction () {
      this.showProduction = false
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + (item.amount ? item.amount : 0) + 'pcs.'
        }
      }
      return categories
    },
    loadPallets () {
      axios.get('/backend/rest/pallet/supplier/' + this.currentSupplier.id)
        .then(response => {
          this.pallets = response.data
          if (this.pallets) {
            for (let p of this.pallets) {
              p.categoriesText = this.categories(p)
            }
          }
        })
    },
    startShowDeliveryReport () {
      this.loadDeliveryReport()
      this.showDeliveryReport = true
    },
    printDeliveryReport () {
      let url = '/backend/print/deliveryReport.xhtml?supplierId=' + this.currentSupplier.id + '&title=Delivery report'
      window.open(url)
    },
    excelDeliveryReport () {
      let url = '/backend/report/deliveryReport?supplierId=' + this.currentSupplier.id
      window.open(url)
    },
    endShowDeliveryReport () {
      this.showDeliveryReport = false
    },
    loadDeliveryReport () {
      this.deliveryReport = null
      axios.get('/backend/rest/delivery_report/supplier/' + this.currentSupplier.id)
        .then(response => {
          this.deliveryReport = response.data
          if (this.deliveryReport && this.deliveryReport.items) {
            let total = 0
            for (let item of this.deliveryReport.items) {
              total += item.amount
            }
            this.deliveryReport.items.push({
              category: null,
              amount: total
            })
          }
        })
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    },
    getContractorNames (supplier) {
      let names = ''
      if (supplier && supplier.contractors && supplier.contractors.length) {
        for (let contractor of supplier.contractors) {
          if (names !== '') {
            names += ', '
          }
          names += contractor.name
        }
      }
      return names
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  tr.supplierFields td:not(.action) {
    padding: 0 0 0 15px !important;
  }
  tr.supplierFields td.action {
    padding: 0 8px !important;
  }
  tr.supplierFields td .v-input {
    padding: 0 !important;
  }
  tr.supplierPickupAddresses td:not(.action) {
    padding: 0 0 0 15px !important;
  }
  tr.supplierPickupAddresses td.action {
    padding: 0 8px !important;
  }
  tr.supplierPickupAddresses td .v-input {
    padding: 0 !important;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Suppliers.vue